(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-image"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('dialog-component.popup-image').forEach((popup) => {
    const delay = Number(popup.dataset.popupDelay) || 0;
    const show = () => popup.showDialog?.();
    delay > 0 ? setTimeout(show, delay) : show();
  });

  } catch(e) { console.error(e); }
})();
})();
